import { AxiosInstance } from "axios";

/**
 * Team → Health → Lead ingestion (C-16 S8, GLE-8406): Command Center's
 * lead-ingestion snapshot, computed by the server for one workspace (Admins
 * and its LGA). Behind `user_roles_lead_ingestion_enabled` (manage/me
 * `features.lead_ingestion`); off, the route answers 404 + 1035.
 */

/** One valid ingestion with its lifetime numbers. Dates are ET, "2006-01-02". */
export interface LeadIngestionI {
  campaign_id: string;
  campaign_name: string | null;
  ingestion_id: string;
  ingestion_name: string | null;
  ingestion_type: string | null;
  /** "Customer" (csv), "User" (a caller's own CSV) or "Other". */
  ingestion_source: string;
  ingestion_created_date: string;
  ingestion_user_id: string | null;
  ingestion_user_name: string | null;
  total_contacts: number;
  total_accounts: number;
  leads_cold: number;
  leads_nurture: number;
  leads_dq: number;
  leads_dq_suppressed: number;
  leads_cold_not_dialed: number;
  leads_cold_under_10_dials: number;
  leads_cold_10plus_dials: number;
  /** Contacts less the cold ones never dialed. */
  leads_penetrated: number;
  /** Contacts less the cold ones under 10 dials. */
  leads_completed: number;
  total_calls: number;
  contacts_dialed: number;
  accounts_dialed: number;
  booked_meetings: number;
  unique_booked_meetings: number;
  voicemail_not_left: number;
  voicemail_left: number;
  data_wrong: number;
  bad_phone_number: number;
  not_qualified_need: number;
  not_qualified_timing: number;
  not_qualified_budget: number;
  not_qualified_authority: number;
  interested: number;
  other_follow_up: number;
  pitch_rejected: number;
  pitch_rejected_dm: number;
  other_do_not_follow_up: number;
  more_materials: number;
  do_not_call: number;
  intro_rejected: number;
  intro_rejected_dm: number;
  gatekeeper_rejected: number;
  qc_not_met_for_account: number;
  other_generic: number;
  unknown_disposition: number;
  no_disposition: number;
}

export interface LeadIngestionsI {
  /** When the numbers were read (cached up to 30 minutes). */
  computed_at: string;
  ingestions: Array<LeadIngestionI>;
}

export const ManageLeadIngestionsAPIEndpoints = (api: AxiosInstance) => ({
  listLeadIngestions: (workspaceId: string) =>
    api.get<LeadIngestionsI>(
      `/v1/manage/workspace/${encodeURIComponent(workspaceId)}/lead_ingestions`
    ),
});
